import { FC, PropsWithChildren } from "react";
import { Button, Buttons, Modal } from "capitalrx-components-2.0/lib/general";
import { styled } from "styled-components";
import { Shelf } from "capitalrx-components-2.0/lib/layout";


interface ConditionalErrorModalProps {
  isVisible: boolean;
  title: string;
  onClose: (canContinue: boolean) => void;
  approveText?: string;
  denyText?: string;
  canContinue?: boolean;
}

const ThemedButton = styled(Button)`
  &.primary {
    background: #60646d !important;
    border-color: #60646d !important;
  }

  &.secondary {
    border-color: #60646d !important;
    div {
      color: #60646d !important;
    }
  }
`;

export const ConditionalErrorModal: FC<PropsWithChildren<ConditionalErrorModalProps>> = (props) => {
  const { isVisible, title, onClose, approveText = "Continue", denyText = "Deny", children, canContinue = false } = props;

  return (
    <Modal
      title={title}
      visible={isVisible}
      onClose={() => onClose(false)}
      footer={
        <Shelf spacing={canContinue ? "small" : undefined}>
          <Shelf.Spacer />
          {canContinue && (
            <ThemedButton appearance={Buttons.Functional.Secondary.Large} onClick={() => onClose(false)}>
              {denyText}
            </ThemedButton>
          )}
          <ThemedButton appearance={Buttons.Functional.Primary.Large} onClick={() => onClose(canContinue)}>
            {canContinue ? approveText : denyText}
          </ThemedButton>
        </Shelf>
      }
    >
      {children}
    </Modal>
  );
};
